import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rank",
  "use": "icon-rank-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rank\"><path d=\"M864 64l-768 0C78.336 64 64 78.336 64 96S78.336 128 96 128L128 128l0 857.6c0 28.544 33.152 46.208 59.2 31.488l258.752-145.856c20.928-11.904 47.168-11.904 68.096 0l258.752 145.856C798.848 1031.808 832 1014.208 832 985.6L832 128l32 0C881.664 128 896 113.664 896 96S881.664 64 864 64z\" p-id=\"1083\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/rank.svg
// module id = 8L7i
// module chunks = 42